/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  useEffect, useRef, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import BurgerMenu from '../../svgs/burger-menu';
import styles from './MainNav.module.scss';
import { useWindowSize, useSticky } from '../../Utils';
import '../../Utils/css';

const MobileMenu = ({ main, aside, openSearch }) => {
  const className = [
    styles['main-nav__mobile-menu'],
    openSearch ? styles['--search-open'] : '',
  ].css();

  return (
    <div className={className}>
      {main}
      {aside}
    </div>
  );
};

MobileMenu.propTypes = {
  main: PropTypes.node.isRequired,
  aside: PropTypes.node.isRequired,
  openSearch: PropTypes.bool.isRequired,
};

/**
 * Main Navigation
 */
export default function MainNav({
  logo = null,
  main = null,
  aside = null,
  bottom = null,
  search = null,
  theme = null,
  background = 'white',
  floating = false,
  sticky = false,
  openSearch = false,
  setOpenSearch = () => {},
  mobileMenuOpen = false,
  setMobileMenuOpen = () => {},
  setIsStickyProp = () => {},
}) {
  const { width } = useWindowSize(200);
  const stickyRef = useRef(null);
  const { isSticky, sentinelRef } = useSticky(stickyRef, 100);

  useEffect(() => {
    setIsStickyProp?.(isSticky);
  }, [isSticky]);

  const containerClassName = [
    styles['main-nav'],
    mobileMenuOpen ? styles['--mobile'] : '',
    theme && !isSticky && !mobileMenuOpen && !openSearch ? styles[`--theme-${theme}`] : styles['--theme-black'],
    background && !isSticky && !mobileMenuOpen && !openSearch ? styles[`--background-${background}`] : styles['--background-white'],
    floating && bottom == null ? styles['--floating'] : '',
    sticky ? styles['--sticky'] : '',
  ].css();

  useEffect(() => {
    if (width > 1197) {
      setMobileMenuOpen(false);
      setOpenSearch(false);
    }
  }, [width]);

  const closeIfOutsideClick = useCallback((e) => {
    if ((!mobileMenuOpen && !openSearch) || width > 1197) return;

    const isInside = stickyRef.current?.contains(e.target);
    const isLink = e.target.tagName === 'A';

    if (!isInside) {
      if (openSearch) setOpenSearch(false);
      if (mobileMenuOpen) setMobileMenuOpen(false);
      return;
    }

    if (mobileMenuOpen && isLink) {
      setMobileMenuOpen(false);
      if (openSearch) setOpenSearch(false);
    }
  }, [mobileMenuOpen, openSearch, stickyRef]);

  useEffect(() => {
    window.addEventListener('click', closeIfOutsideClick);
    return () => {
      window.removeEventListener('click', closeIfOutsideClick);
    };
  }, [closeIfOutsideClick]);

  const onBurgerMenuClick = () => {
    if (openSearch) {
      setOpenSearch(false);
    } else {
      setMobileMenuOpen(!mobileMenuOpen);
    }
  };

  return (
    <>
      <div ref={sentinelRef} />
      <div className={containerClassName} ref={stickyRef}>
        <div className={styles['main-nav__container']}>
          <div className={styles['main-nav__logo']}>{logo}</div>
          {!mobileMenuOpen && (
            <>
              <div className={styles['main-nav__main']}>{main}</div>
              <div className={styles['main-nav__aside']}>{aside}</div>
            </>
          )}
          <div className={styles['main-nav__mobile-menu-button-wrapper']} onClick={(e) => e.stopPropagation()}>
            {search}
            <button type="button" className={[styles['main-nav__mobile-menu-button'], mobileMenuOpen && !openSearch ? styles['--active'] : ''].join(' ')} onClick={onBurgerMenuClick}><BurgerMenu /></button>
          </div>
          {mobileMenuOpen && <MobileMenu main={main} aside={aside} openSearch={openSearch} />}
        </div>
        {bottom}
      </div>
    </>
  );
}

MainNav.propTypes = {
  logo: PropTypes.node,
  main: PropTypes.node,
  aside: PropTypes.node,
  bottom: PropTypes.node,
  search: PropTypes.node,
  theme: PropTypes.oneOf(['white']),
  background: PropTypes.oneOf(['transparent', 'white']),
  floating: PropTypes.bool,
  sticky: PropTypes.bool,
  openSearch: PropTypes.bool,
  setOpenSearch: PropTypes.func,
  setMobileMenuOpen: PropTypes.func.isRequired,
  mobileMenuOpen: PropTypes.bool.isRequired,
  setIsStickyProp: PropTypes.func,
};

MainNav.styles = {
  twoColumn: styles['--two-column'],
  hideMobile: styles['--hide-mobile'],
};
